import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import moment from 'moment';
import { HomeService } from 'services';
import { Constants, Globals, checkPermission, Permissions } from 'utils';
import { ArrowRight } from 'assets/icons';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Home extends React.Component<Props> {

	state = {
		plans: [],
		suscriptions: [],
		bank_accounts: [],
		register_history: [],
		quotes: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Inicio',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async () => {
		const res: any = await HomeService.admin.get({
			user_id: this.props.user?.id
		});
		this.setState({
			plans: res.plans,
			suscriptions: res.plan_payments || [],
			bank_accounts: res.bank_accounts || [],
			register_history: res.users || [],
			quotes: res.quotes || []
		});
	}
	
	render() {
		return (
			<>
			</>
		)
		// return (
		// 	<div id="admin-home">
		// 		<div className="row">
		// 			{
		// 				checkPermission(Constants.MODULES.PLANS,'read',this.props.user) && (
		// 					<div className="col-md-4">
		// 						<div className="container-card pink">
		// 							<h3>Historial de Suscripción</h3>
		// 							<table className="table">
		// 								<thead>
		// 									<tr>
		// 										<th>Fecha</th>
		// 										<th>Usuario</th>
		// 										<th>Plan de Suscripción</th>
		// 									</tr>
		// 								</thead>
		// 								<tbody>
		// 									{
		// 										this.state.suscriptions.map((item: any, index: number) => {
		// 											return (
		// 												<tr>
		// 													<td>{ moment(item?.next_payment).format('DD-MM-YYYY') }</td>
		// 													<td>{ item?.plan_user?.user?.name }</td>
		// 													<td>{ item?.plan_user?.plan?.name }</td>
		// 												</tr>
		// 											)
		// 										})
		// 									}
		// 									{
		// 										this.state.suscriptions.length == 0 && (
		// 											<tr>
		// 												<td align="center" colSpan={ 3 }>No hay registros para mostrar</td>
		// 											</tr>
		// 										)
		// 									}
		// 								</tbody>
		// 							</table>
		// 							{
		// 								this.state.suscriptions.length > 0 && (
		// 									<Link to="/admin/plans/history" className="view-more">
		// 										Ver Más <img src={ ArrowRight } />
		// 									</Link>
		// 								)
		// 							}
		// 						</div>
		// 					</div>
		// 				)
		// 			}
		// 			{
		// 				checkPermission(Constants.MODULES.BANK_ACCOUNTS,'read',this.props.user) && (
		// 					<div className="col-md-4">
		// 						<div className="container-card">
		// 							<h3>Cuentas Bancarias</h3>
		// 							<table className="table">
		// 								<thead>
		// 									<tr>
		// 										<th>Tipo de Cuenta</th>
		// 										<th>Número de Cuenta</th>
		// 										<th>Estatus</th>
		// 									</tr>
		// 								</thead>
		// 								<tbody>
		// 									{
		// 										this.state.bank_accounts.map((item: any, index: number) => {
		// 											return (
		// 												<tr>
		// 													<td>{ item.type_text }</td>
		// 													<td>{ item.number }</td>
		// 													<td>{ item.status_text }</td>
		// 												</tr>
		// 											)
		// 										})
		// 									}
		// 									{
		// 										this.state.bank_accounts.length == 0 && (
		// 											<tr>
		// 												<td align="center" colSpan={ 3 }>No hay registros para mostrar</td>
		// 											</tr>
		// 										)
		// 									}
		// 								</tbody>
		// 							</table>
		// 							{
		// 								this.state.bank_accounts.length > 0 && (
		// 									<Link to="/admin/banks" className="view-more">
		// 										Ver Más <img src={ ArrowRight } />
		// 									</Link>
		// 								)
		// 							}
		// 						</div>
		// 					</div>
		// 				)
		// 			}
		// 			{
		// 				checkPermission(Constants.MODULES.PLANS,'read',this.props.user) && (
		// 					<div className="col-md-4">
		// 						<div className="container-plans">
		// 							<h4>Precios Actuales</h4>
		// 							{
		// 								this.state.plans.map((item: any) => {
		// 									return (
		// 										<div className="item-plan active">
		// 											<div className="container-image">
		// 												<img src={ Constants.BASE_PUBLIC + 'img/' + item.icon } />
		// 											</div>
		// 											<div className="container-data">
		// 												<p>{ item.name }</p>
		// 												<p className="bold">{ Globals.formatMiles(item.amount) }</p>
		// 											</div>
		// 										</div>
		// 									)
		// 								})
		// 							}
		// 						</div>
		// 					</div>
		// 				)
		// 			}
		// 			{
		// 				checkPermission(Constants.MODULES.REGISTER,'read',this.props.user) && (
		// 					<div className="col-md-6">
		// 						<div className="container-card blue">
		// 							<h3>Historial de registro</h3>
		// 							<table className="table">
		// 								<thead>
		// 									<tr>
		// 										<th>Fecha</th>
		// 										<th>Nombre y apellido</th>
		// 										<th>Documento</th>
		// 									</tr>
		// 								</thead>
		// 								<tbody>
		// 									{
		// 										this.state.register_history.map((item: any, index: number) => {
		// 											return (
		// 												<tr>
		// 													<td>{ moment(item.created_at).format('DD/MM/YYYY') }</td>
		// 													<td>{ item.name }</td>
		// 													<td>{ item.document_type?.name }{ item.document }</td>
		// 												</tr>
		// 											)
		// 										})
		// 									}
		// 									{
		// 										this.state.register_history.length == 0 && (
		// 											<tr>
		// 												<td align="center" colSpan={ 3 }>No hay registros para mostrar</td>
		// 											</tr>
		// 										)
		// 									}
		// 								</tbody>
		// 							</table>
		// 							{
		// 								this.state.register_history.length > 0 && (
		// 									<Link to="/admin/register" className="view-more">
		// 										Ver Más <img src={ ArrowRight } />
		// 									</Link>
		// 								)
		// 							}
		// 						</div>
		// 					</div>
		// 				)
		// 			}
		// 			{
		// 				checkPermission(Constants.MODULES.QUOTES,'read',this.props.user) && (
		// 					<div className="col-md-6">
		// 						<div className="container-card">
		// 							<h3>Cotización</h3>
		// 							<h4>Últimas enviadas</h4>
		// 							<table className="table">
		// 								<thead>
		// 									<tr>
		// 										<th>Fecha de solicitud</th>
		// 										<th>Tipo de Cirugía</th>
		// 										<th>Médico tratante</th>
		// 									</tr>
		// 								</thead>
		// 								<tbody>
		// 									{
		// 										this.state.quotes.map((item: any, index: number) => {
		// 											return (
		// 												<tr>
		// 													<td>{ moment(item.created_at).format('DD-MM-YYYY') }</td>
		// 													<td>{ item?.service?.name }</td>
		// 													<td>{ item?.user?.name }</td>
		// 												</tr>
		// 											)
		// 										})
		// 									}
		// 									{
		// 										this.state.quotes.length == 0 && (
		// 											<tr>
		// 												<td align="center" colSpan={ 4 }>No hay registros para mostrar</td>
		// 											</tr>
		// 										)
		// 									}
		// 								</tbody>
		// 							</table>
		// 							{
		// 								this.state.quotes.length > 0 && (
		// 									<Link to="/admin/quotes" className="view-more">
		// 										Ver Más <img src={ ArrowRight } />
		// 									</Link>
		// 								)
		// 							}
		// 						</div>
		// 					</div>
		// 				)
		// 			}
		// 		</div>
		// 	</div>
		// )
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Home);